module.exports = __webpack_public_path__ + "img/max.d5af1cf.png";